export default {
	data() {
		return { 
			features: {
				contexts: false,
				dashboard: false,
				dates: false,
				import: false,
				filters: false,
				folders: false, 
				kanban: false,
				markdown: false,
				mobile: false,
				nestedFolders: false, 
				priorities: false,
				reminders: false, 
				repeatingTasks: false,
				stars: false,
				statuses: false,
				subTasks: false,
				templates: false,
				visibility: false,
			},
			featureText: {
				contexts: 'Organize tasks based on your context.',
				dashboard: 'Review your obligations and productivity.',
				dates: 'Keep of track start and due dates/times.',
				import: 'Import your data from other task managers.',
				filters: 'Customize the tasks you see.',
				folders: 'Organize like tasks',
				kanban: 'Interact with your tasks on a Kanban board.',
				markdown: 'HARDCODED',
				mobile: 'Use any device you have available.',
				nestedFolders: 'Group like folders.',
				priorities: 'Organize tasks based on their importance.',
				reminders: 'Reminders help you to never miss a deadline',
				repeatingTasks: 'Automatically create recurring tasks.',
				stars: 'Flag the highest-priority tasks.',
				statuses: 'Keep track of "where" each task is.',
				subTasks: 'Create a plan by adding sub-tasks.',
				templatesGeneric: 'Use task templates (reusable lists).',
				templatesPrivate: 'Create your own task templates (reusable lists).',
				templatesPublic: 'Use task templates (reusable lists) created by others.',
				visibility: 'Control how much detail is displayed.',
			},
			opacity: 0.60,
			variant: 'info'
	    	}
	},
	methods: {
		over(id) {
			
			Object.keys(this.features).forEach((key) => {
				
				if(key != id) {
					this.features[key] = false
				}
			})

			this.features[id] = true
			
			
		}
	}, 
}